"use client";

import { c as _c } from "react/compiler-runtime";
import type { Route } from "next";
import { Button } from "@workspace/ui/components/button";
import { Field, FieldDescription, FieldError, FieldGroup, FieldLabel, FieldLegend, FieldSet } from "@workspace/ui/components/field";
import { Input } from "@workspace/ui/components/input";
import { useLocale, useTranslations } from "next-intl";
import { useSearchParams } from "next/navigation";
import { useActionState, useEffect, useId, useRef, useState } from "react";
import { Link } from "@/i18n/navigation";
import { splitOutLocale } from "@/lib/split-out-locale";
import type { LoginState } from "./page";
export function LoginForm(t0) {
  const $ = _c(106);
  const {
    loginAction
  } = t0;
  const locale = useLocale();
  const searchParams = useSearchParams();
  let next = (searchParams.get("next") ?? `/${locale}/dashboard`) as Route;
  if (!next.startsWith("/")) {
    next = `/${locale}/dashboard` as Route;
  }
  const t = useTranslations();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [state, dispatchAction, isPending] = useActionState(loginAction, t1);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const formRef = useRef(null);
  const errorRef = useRef(null);
  const formFieldId = useId();
  let t2;
  if ($[1] !== state.emailError || $[2] !== state.error || $[3] !== state.passwordError) {
    t2 = () => {
      if (state.emailError) {
        emailRef.current?.focus();
      } else {
        if (state.passwordError) {
          passwordRef.current?.focus();
        } else {
          if (state.error) {
            errorRef.current?.focus();
          }
        }
      }
    };
    $[1] = state.emailError;
    $[2] = state.error;
    $[3] = state.passwordError;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== state) {
    t3 = [state];
    $[5] = state;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== t) {
    t4 = t("Pages.Auth.Login.title");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <FieldLegend variant="legend"><h1 className="text-2xl">{t4}</h1></FieldLegend>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("AuthAudit.noAccount");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("AuthAudit.createAccount");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <Link href="/auth/sign-up" className="underline underline-offset-4">{t7}</Link>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <FieldDescription>{t6}{" "}{t8}</FieldDescription>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = typeof state?.emailError !== "undefined";
  const t11 = `${formFieldId}-email`;
  let t12;
  if ($[20] !== t) {
    t12 = t("Ui.labels.email");
    $[20] = t;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11 || $[23] !== t12) {
    t13 = <FieldLabel htmlFor={t11}>{t12}</FieldLabel>;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const t14 = `${formFieldId}-email`;
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = event => setEmail(event.target.value);
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  const t16 = state.emailError ? `${formFieldId}-email-error` : undefined;
  const t17 = typeof state?.emailError !== "undefined";
  let t18;
  if ($[26] !== email || $[27] !== isPending || $[28] !== t14 || $[29] !== t16 || $[30] !== t17) {
    t18 = <Input ref={emailRef} id={t14} type="email" name="email" value={email} onChange={t15} autoComplete="username" autoCapitalize="none" spellCheck={false} readOnly={isPending} aria-describedby={t16} aria-invalid={t17} placeholder="m@example.com" required={true} />;
    $[26] = email;
    $[27] = isPending;
    $[28] = t14;
    $[29] = t16;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== formFieldId || $[33] !== state.emailError) {
    t19 = state?.emailError && <FieldError id={`${formFieldId}-email-error`}>{state.emailError}</FieldError>;
    $[32] = formFieldId;
    $[33] = state.emailError;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t10 || $[36] !== t13 || $[37] !== t18 || $[38] !== t19) {
    t20 = <Field data-invalid={t10}>{t13}{t18}{t19}</Field>;
    $[35] = t10;
    $[36] = t13;
    $[37] = t18;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  const t21 = typeof state?.passwordError !== "undefined";
  const t22 = `${formFieldId}-password`;
  let t23;
  if ($[40] !== t) {
    t23 = t("Ui.labels.password");
    $[40] = t;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== t22 || $[43] !== t23) {
    t24 = <FieldLabel htmlFor={t22}>{t23}</FieldLabel>;
    $[42] = t22;
    $[43] = t23;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  const t25 = `${formFieldId}-password`;
  let t26;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = event_0 => setPassword(event_0.target.value);
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  const t27 = `${formFieldId}-password-help${state.passwordError ? ` ${formFieldId}-password-error` : ""}`;
  const t28 = typeof state?.passwordError !== "undefined";
  let t29;
  if ($[46] !== isPending || $[47] !== password || $[48] !== t25 || $[49] !== t27 || $[50] !== t28) {
    t29 = <Input ref={passwordRef} id={t25} type="password" name="password" value={password} onChange={t26} autoComplete="current-password" readOnly={isPending} aria-describedby={t27} aria-invalid={t28} />;
    $[46] = isPending;
    $[47] = password;
    $[48] = t25;
    $[49] = t27;
    $[50] = t28;
    $[51] = t29;
  } else {
    t29 = $[51];
  }
  let t30;
  if ($[52] !== formFieldId || $[53] !== state.passwordError) {
    t30 = state?.passwordError && <FieldError id={`${formFieldId}-password-error`}>{state.passwordError}</FieldError>;
    $[52] = formFieldId;
    $[53] = state.passwordError;
    $[54] = t30;
  } else {
    t30 = $[54];
  }
  const t31 = `${formFieldId}-password-help`;
  let t32;
  if ($[55] !== t) {
    t32 = t("AuthAudit.staffLoginHint");
    $[55] = t;
    $[56] = t32;
  } else {
    t32 = $[56];
  }
  let t33;
  if ($[57] !== t31 || $[58] !== t32) {
    t33 = <FieldDescription id={t31}>{t32}</FieldDescription>;
    $[57] = t31;
    $[58] = t32;
    $[59] = t33;
  } else {
    t33 = $[59];
  }
  let t34;
  if ($[60] !== t) {
    t34 = t("Pages.Auth.Login.forgot-password");
    $[60] = t;
    $[61] = t34;
  } else {
    t34 = $[61];
  }
  let t35;
  if ($[62] !== t34) {
    t35 = <FieldDescription><Link href="/auth/forgot-password" className="ms-auto inline-block text-sm underline-offset-4 hover:underline">{t34}</Link></FieldDescription>;
    $[62] = t34;
    $[63] = t35;
  } else {
    t35 = $[63];
  }
  let t36;
  if ($[64] !== t21 || $[65] !== t24 || $[66] !== t29 || $[67] !== t30 || $[68] !== t33 || $[69] !== t35) {
    t36 = <Field data-invalid={t21}>{t24}{t29}{t30}{t33}{t35}</Field>;
    $[64] = t21;
    $[65] = t24;
    $[66] = t29;
    $[67] = t30;
    $[68] = t33;
    $[69] = t35;
    $[70] = t36;
  } else {
    t36 = $[70];
  }
  let t37;
  if ($[71] !== state.error) {
    t37 = state?.error && <FieldError ref={errorRef} tabIndex={-1}>{state.error}</FieldError>;
    $[71] = state.error;
    $[72] = t37;
  } else {
    t37 = $[72];
  }
  let t38;
  if ($[73] !== t20 || $[74] !== t36 || $[75] !== t37) {
    t38 = <FieldGroup>{t20}{t36}{t37}</FieldGroup>;
    $[73] = t20;
    $[74] = t36;
    $[75] = t37;
    $[76] = t38;
  } else {
    t38 = $[76];
  }
  let t39;
  if ($[77] !== t38 || $[78] !== t5 || $[79] !== t9) {
    t39 = <FieldSet>{t5}{t9}{t38}</FieldSet>;
    $[77] = t38;
    $[78] = t5;
    $[79] = t9;
    $[80] = t39;
  } else {
    t39 = $[80];
  }
  let t40;
  if ($[81] !== isPending || $[82] !== t) {
    t40 = isPending ? t("Ui.general.logging-in") : t("Ui.labels.login");
    $[81] = isPending;
    $[82] = t;
    $[83] = t40;
  } else {
    t40 = $[83];
  }
  let t41;
  if ($[84] !== isPending || $[85] !== t40) {
    t41 = <Button type="submit" disabled={isPending}>{t40}</Button>;
    $[84] = isPending;
    $[85] = t40;
    $[86] = t41;
  } else {
    t41 = $[86];
  }
  let t42;
  if ($[87] !== isPending) {
    t42 = process.env.NODE_ENV === "development" && <Button type="button" variant="secondary" disabled={isPending} onClick={() => {
      if (emailRef.current === null || passwordRef.current === null) {
        return;
      }
      emailRef.current.value = "foo@bar.baz";
      passwordRef.current.value = "password123!";
      setEmail("foo@bar.baz");
      setPassword("password123!");
      if (formRef.current === null) {
        return;
      }
      formRef.current.requestSubmit();
    }}>Testuser</Button>;
    $[87] = isPending;
    $[88] = t42;
  } else {
    t42 = $[88];
  }
  let t43;
  if ($[89] !== t41 || $[90] !== t42) {
    t43 = <Field orientation="horizontal">{t41}{t42}</Field>;
    $[89] = t41;
    $[90] = t42;
    $[91] = t43;
  } else {
    t43 = $[91];
  }
  let t44;
  if ($[92] !== t39 || $[93] !== t43) {
    t44 = <FieldGroup>{t39}{t43}</FieldGroup>;
    $[92] = t39;
    $[93] = t43;
    $[94] = t44;
  } else {
    t44 = $[94];
  }
  const T0 = Input;
  const t45 = "hidden";
  const t46 = "next";
  const t47 = splitOutLocale(next);
  let t48;
  if ($[95] !== T0 || $[96] !== t47) {
    t48 = <T0 type={t45} name={t46} defaultValue={t47} />;
    $[95] = T0;
    $[96] = t47;
    $[97] = t48;
  } else {
    t48 = $[97];
  }
  let t49;
  if ($[98] !== locale) {
    t49 = <Input type="hidden" name="locale" defaultValue={locale} />;
    $[98] = locale;
    $[99] = t49;
  } else {
    t49 = $[99];
  }
  let t50;
  if ($[100] !== dispatchAction || $[101] !== isPending || $[102] !== t44 || $[103] !== t48 || $[104] !== t49) {
    t50 = <form ref={formRef} action={dispatchAction} aria-busy={isPending}>{t44}{t48}{t49}</form>;
    $[100] = dispatchAction;
    $[101] = isPending;
    $[102] = t44;
    $[103] = t48;
    $[104] = t49;
    $[105] = t50;
  } else {
    t50 = $[105];
  }
  return t50;
}